<template>
  <div
    :class="[
      'm-event',
      {
        live: isLive,
        tennis: event.sportId === 'sr:sport:5'
      }
    ]"
  >
    <div class="m-event--header">
      <div class="flex-start">
        <!-- 比赛时间 -->
        <div
          v-if="isLive"
          class="m-time m-live-time"
        >
          <span
            v-if="matchTime"
            class="m-show-time"
            >{{ matchTime }} &nbsp;</span
          >
          <span
            v-if="formattedStoppageTime"
            class="m-stoppage-time"
            >{{ formattedStoppageTime }} &nbsp;</span
          >
          <span
            v-if="matchStage"
            :class="['m-status', { 'm-status-live': isLive }]"
            >{{ matchStage }}</span
          >
        </div>

        <template v-else>
          <span class="m-time">{{ matchTime }}</span>
        </template>

        <div
          v-if="isShowTournamentInfo"
          class="m-tournament-name"
          v-html="leagueName"
        />
      </div>

      <EarlyPayout
        :market="marketLabels"
        type="medium"
      />

      <BtnStats
        class="m-tracker-btn"
        :active="trackerVisible"
        @click="openTracker"
      />
    </div>

    <div class="m-event--main tw-flex tw-items-center tw-justify-between">
      <div class="m-teams">
        <router-link
          class="m-teams--info-wrap"
          :to="matchLink"
          :aria-label="ariaLabel"
          @click.native="handleClick"
        >
          <div class="m-teams--info active:tw-text-gray-6">
            <div class="m-server-name-wrapper">
              <img
                v-if="isServerVisible"
                class="m-server-icon"
                :class="{ active: isHomeServer }"
                :src="serverIcon"
              />
              <div
                class="m-home-team tw-truncate tw-w-full"
                v-html="homeTeam"
              />
            </div>

            <div class="m-server-name-wrapper">
              <img
                v-if="isServerVisible"
                class="m-server-icon"
                :class="{ active: isAwayServer }"
                :src="serverIcon"
              />
              <div
                class="m-away-team tw-truncate tw-w-full"
                v-html="awayTeam"
              />
            </div>
          </div>

          <!-- live 比赛显示比分 -->
          <MatchScores
            v-if="isLive"
            class="m-teams--score"
            :score-of-whole-match="match.scoreOfWholeMatch"
            :score-of-section="match.scoreOfSection"
            :score-in-current-section="match.scoreInCurrentSection"
          />
        </router-link>
      </div>

      <Market8Range
        v-if="presentationType === 8"
        :event="event"
        :market="(marketMap[currentMarketId] || [])[0]"
        :has-scales="false"
        :scale-num="outcomeSize"
        :oddsfiltered="oddsfiltered"
        visible
      />

      <SuperMarket7
        v-else-if="presentationType === 7"
        :market="marketMap[currentMarketId] || []"
        :sport-id="event.sportId"
        :market-id="currentMarketId"
        :outcome-size="outcomeSize"
        :market-titles="marketTitles"
        :event="event"
      />

      <Market
        v-else
        class="m-market"
        :market="marketMap[currentMarketId]"
        :market-id="currentMarketId"
        :outcome-size="outcomeSize"
        :market-titles="marketTitles"
        :event="event"
        :key-points="keyPoints"
      />
    </div>

    <router-link
      class="m-event--footer"
      :to="matchLink"
      :aria-label="ariaLabel"
      @click.native="handleClick"
    >
      <!-- 可投注market数量 -->
      <span class="m-market-num"
        ><span>+{{ event.marketsCount }}</span> <svg-icon icon-class="icon-arrowright-new"
      /></span>
      <template v-if="isBooked">
        <IconPlay
          v-if="event.hasLive"
          class="label-tag"
        />

        <IconCommentary
          v-else-if="isLive && event.hasLiveCoverage"
          class="label-tag"
          :width="18"
          :height="14"
        />
      </template>

      <IconCommentaryCount
        v-if="isLive && event.commentCount"
        class="label-tag"
      >
        {{ parsedCommentCount }}
      </IconCommentaryCount>

      <IconHot
        v-if="event.isTopTeam"
        class="label-tag"
        :width="18"
        :height="14"
      />

      <!-- match label -->
      <IconMatchLabels
        class="tw-h-[12px]"
        :options="{
          configKey: 'commonLabeUrl',
          displayIn: '3',
          sportId: event.sportId,
          tournamentId: event.tournamentId,
          eventStatus: event.status
        }"
      />
    </router-link>

    <VDialogBox
      :visible="trackerVisible"
      class="m-event-tracker-container"
      :class="{ vSoccer: isVSoccer }"
      @close="closeTracker"
    >
      <StatWidgets
        v-if="trackerVisible"
        class="list-stat-widgets"
        :event="event"
        :event-id="event.eventId"
        :sport-id="event.sportId"
        :round-type="event.roundType"
        :start-time="event.startTime"
        :is-inner-scroll="true"
        dialog
        styleType="line"
        tabs-position="top"
      />
    </VDialogBox>
  </div>
</template>

<script>
import { ref, onUnmounted, onDeactivated, computed } from '@vue/composition-api'
import VDialogBox from 'fe-vui/dialogBox'
import { useSportServer } from 'composables/useSportServer'
import { prefillMatchSummary } from '@ms/components/match/useMatchInfo.js'
import useMatch from '@ms/components/match/useMatch.js'
import MatchScores from '@ms/components/match/MatchScores.vue'
import modalHelper from '@ms/utils/scroll-fixed'
import IconMatchLabels from '@ms/components/IconMatchLabels.vue'
import eventBus from '@ms/utils/event-bus.js'
import Market8Range from 'wap/match/markets/Market8Range.vue'
import Market from '../Event/pagelet/Market'
import SuperMarket7 from '../Event/pagelet/SuperMarket7'
import BtnStats from '@ms/components/BtnStats.vue'
import EarlyPayout from '@ms/components/market/EarlyPayout.vue'
import 'base/icons/svg/arrowright-new.svg'
import IconPlay from 'assets/theme/IconPlay.vue'
import IconHot from 'assets/theme/IconHot.vue'
import IconCommentary from 'assets/theme/IconCommentary.vue'
import IconCommentaryCount from 'assets/theme/IconCommentaryCount.vue'

export default {
  name: 'SportMatch',
  components: {
    VDialogBox,
    MatchScores,
    IconMatchLabels,
    StatWidgets: () => import(/* webpackPrefetch: true, webpackChunkName: 'stat-widgets' */ 'wap/components/StatWidgets'),
    Market,
    Market8Range,
    SuperMarket7,
    BtnStats,
    EarlyPayout,
    IconPlay,
    IconHot,
    IconCommentary,
    IconCommentaryCount
  },
  props: {
    event: {
      type: Object,
      default: () => ({})
    },
    isShowTournamentInfo: {
      type: Boolean,
      default: true
    },
    // market 布局类型，同比赛详情页
    presentationType: {
      type: Number,
      default: 0
    },
    currentMarketId: {
      type: [String, Number],
      default: ''
    },
    outcomeSize: {
      type: Number,
      default: 3
    },
    marketTitles: {
      type: Array,
      default: () => []
    },
    marketIds: {
      type: Array,
      default: () => []
    },
    // 是否需要筛选 odds
    oddsfiltered: {
      type: Boolean,
      default: false
    },
    keyword: {
      type: String,
      default: ''
    },
    keyPoints: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    const event = computed(() => props.event)
    const sportId = computed(() => props.event.sportId)
    const isVSoccer = computed(() => event.value?.sportId === 'lv:sport:1')

    const { isLive, isBooked, isActive, match, server, marketMap, matchTime, formattedStoppageTime, matchLink, ariaLabel, matchStage } = useMatch(
      { event, marketIds: props.marketIds, excludeStages: ['H1', 'H2'] },
      { sublist: ['match', 'market', 'odds'] }
    )

    const trackerVisible = ref(false)

    const marketLabels = computed(() => {
      const market = marketMap.value[props.currentMarketId]
      if (Array.isArray(market)) {
        return market[0]
      }
      return market
    })

    const openTracker = () => {
      trackerVisible.value = true
      modalHelper.afterOpen()
      window.dataLayer.push({ event: 'MatchList_StatsClick' })
    }

    const closeTracker = () => {
      modalHelper.beforeClose()
      trackerVisible.value = false
    }

    onUnmounted(() => {
      if (trackerVisible.value) closeTracker()
      eventBus.$off('VSOCCER_CLOSE_WIDGETS')
    })

    onDeactivated(() => {
      if (trackerVisible.value) closeTracker()
      eventBus.$off('VSOCCER_CLOSE_WIDGETS')
    })

    const prefillMatchDetail = () => {
      prefillMatchSummary(props.event)
    }

    const { serverIcon, isServerVisible, isHomeServer, isAwayServer } = useSportServer({
      sportId,
      server,
      isLive
    })

    return {
      matchTime,
      formattedStoppageTime,
      isLive,
      isBooked,
      isActive,
      match,
      marketMap,
      matchLink,
      ariaLabel,
      matchStage,
      trackerVisible,
      marketLabels,
      openTracker,
      closeTracker,
      isVSoccer,
      prefillMatchDetail,
      isServerVisible,
      serverIcon,
      isHomeServer,
      isAwayServer
    }
  },
  computed: {
    parsedCommentCount() {
      const { commentCount } = this.event
      return commentCount > 99 ? '99+' : commentCount
    },
    homeTeam() {
      const { homeTeam } = this.event
      return this.regFn(homeTeam)
    },
    awayTeam() {
      const { awayTeam } = this.event
      return this.regFn(awayTeam)
    },
    leagueName() {
      const { category, tournament } = this.event
      const categoryName = this.regFn(category)
      const tournamentName = this.regFn(tournament)
      return `${categoryName} - ${tournamentName}`
    },
    isGoalStreak() {
      const goalStreakIdList = ['3000021', '3000022', '3000027']
      return goalStreakIdList.includes(this.currentMarketId)
    }
  },
  mounted() {
    eventBus.$on('VSOCCER_CLOSE_WIDGETS', this.closeTracker)
  },
  methods: {
    handleClick() {
      if (this.keyword) eventBus.$emit('search_to_event')
      this.prefillMatchDetail()
    },
    regFn(value) {
      const { keyword } = this
      if (keyword) {
        const replaceReg = new RegExp(`(${keyword})`, 'gi')
        return value.replace(replaceReg, '<span class="search-text">$1</span>')
      } else {
        return value
      }
    }
  }
}
</script>

<style lang="less">
.m-event {
  // tennis live 比赛有3列比分
  &.tennis {
    .m-event--main {
      .m-teams {
        &--score {
          width: 52px;
        }
      }
    }
  }

  .m-event-early {
    margin-bottom: 3px;
  }

  .search-text {
    color: @primary;
  }

  .m-tracker-btn {
    width: 26px;
    height: 22px;
    padding-left: 10px;
  }
}

.m-event--header {
  display: flex;
  height: 22px;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 2px;
  color: #999;
  font-size: 10px;
  line-height: 22px;

  .m-event-early {
    padding: 0;
    margin: 0;
  }

  .flex-start {
    display: flex;
    width: 92%;
    flex: 1;
    align-items: center;
    justify-content: flex-start;
    .ellipsis();
  }

  .m-time {
    margin-right: 6px;
    white-space: nowrap;
  }

  .m-live-time {
    & > span {
      color: #fff;
    }

    .m-status {
      margin-right: 6px;
    }

    .m-status-live {
      color: #ffca27;
    }

    .m-show-time {
      display: inline-block;
      min-width: 30px;
      color: @primary;
    }

    .m-stoppage-time {
      color: #999;
    }
  }

  .m-tournament-name {
    width: 80%;
    .ellipsis();
  }
}

.m-event--main {
  .m-teams {
    position: relative;
    width: 38%;
    flex: auto;
    padding: 2px 0;
    margin-right: 12px;
    font-size: 12px;
    line-height: 16px;

    .m-teams--info-wrap {
      display: flex;
      overflow: hidden;
      max-width: 100%;
      align-items: center;
      justify-content: space-between;
      color: #f8f8f8;
    }

    .m-teams--info {
      width: 30%;
      flex: 1;
      .ellipsis();

      .m-server-name-wrapper {
        display: flex;
        align-items: center;

        &:first-child {
          margin-bottom: 8px;
        }

        .m-server-icon {
          width: 8px;
          height: 8px;
          margin-right: 6px;
          filter: brightness(0.4) grayscale(1);

          &.active {
            filter: brightness(1) grayscale(0);
          }
        }
      }
    }

    &--score {
      width: 26px;
      max-width: 52px;

      .m-score-wrap {
        color: #999;
      }
    }
  }

  .m-market-range,
  .m-market {
    max-width: (208/360) * 100%;
    flex: none;
  }

  .m-market-range {
    width: 208px;
  }
}

.m-event--footer {
  display: inline-block;
  color: #999;
  font-size: 10px;

  .m-market-num {
    margin-right: 4px;
    vertical-align: middle;

    .svg-icon {
      margin: -2px 0 0 -2px;
      font-size: 10px;
    }
  }

  .label-tag {
    height: 14px;
    margin-right: 4px;
    vertical-align: middle;
  }
}

.m-event-tracker-container {
  .dialog {
    overflow: hidden;
    width: 100%;
    min-width: 320px;
    border-radius: 20px;
    margin: 0 15px;
    background: #1a1a1a;

    .m-close-btn {
      height: 20px;
      padding: 12px 14px;
      color: white;

      svg {
        height: 20px;
      }
    }
  }

  .m-stats-widgets {
    &::before {
      display: block;
      width: 100%;
      height: 44px;
      content: '';
    }

    &.list-stat-widgets {
      .m-stats-navs {
        top: 0;
      }
    }

    &.line {
      .m-stats-widgets-navs {
        height: 44px;
        border-color: #2b2b2b;
        background: #141414;

        .snap-nav {
          border-radius: 0;
        }
      }
    }
  }

  .m-widgets-container {
    @dialog-header-height: 75px;

    height: calc(70vh - @dialog-header-height); // legacy browser support
    height: calc(70dvh - @dialog-header-height);
    border-radius: 0 0 20px 20px;
    background: #333;
    overflow-x: hidden;
    overflow-y: auto;

    .m-widgets,
    .sr-bb {
      background: transparent;
    }
  }
}
</style>

<style lang="scss" scoped>
@use 'wap/common/style/vars.scss' as vars;

.m-event {
  position: relative;
  min-height: 100px;
  box-sizing: border-box;
  padding: 5px 10px;
  border-radius: 8px;
  margin: 4px 10px;
  background: #161616;
  color: #f8f8f8;
  user-select: none;

  &.live {
    &::before {
      position: absolute;
      top: 0;
      left: 0;
      overflow: hidden;
      width: 10px;
      height: 100%;
      border-radius: 8px 0 0 8px;
      background-image: linear-gradient(270deg, rgba(0, 0, 0, 0%) 0%, rgba(255, 125, 30, 40%) 100%);
      content: '';
    }
  }
}

.m-event--footer {
  height: 22px;
  line-height: 22px;
}

[data-mode='light'] {
  .m-event {
    background: #fff;
  }

  .m-event--main .m-teams .m-teams--info-wrap {
    color: #000;
  }

  .m-event--header .m-live-time {
    .m-status-live,
    .m-show-time {
      color: #ff7d1e;
    }
  }
}

::v-deep {
  .container {
    background: #222;
  }
}

@media screen and (max-width: 325px) {
  div.title {
    font-size: 10px;
  }
}
</style>
